import { Centered } from "@/components/Centered/Centered.ts"
import { pageTitle } from "@/lib/displayUtils.ts"
import { Page } from "@/routes/auth/Page.tsx"
import { HomeStyles } from "@/routes/home/HomeStyles.ts"


export const SandboxScene = () => {
  return (
    <Page>
      <Centered vertical={false}>
        <HomeStyles.List>
          <title>{pageTitle("Sandbox")}</title>
          <HomeStyles.ListTitle>Sandbox</HomeStyles.ListTitle>
        </HomeStyles.List>
      </Centered>
    </Page>
  )
}